function TabButton({

    text,

    active,

    onClick

}){

    return(

        <div

            onClick={onClick}

            style={{

                flex:1,

                textAlign:"center",

                padding:"14px",

                cursor:"pointer",

                background:active ? "#1976d2" : "#fff",

                color:active ? "#fff" : "#444",

                fontWeight:600,

                transition:"0.2s"

            }}

        >

            {text}

        </div>

    );

}

export default TabButton;